export default __webpack_public_path__ + "static/media/kuvik_banner.db2e9e50.gif";